<template>
  <form @submit.prevent="handleSubmit">
    <modal-card :title="title">
      <b-field label="Publisher">
        <publisher-select :current="account ? account.publisher : null" v-model="form.publisher_id"></publisher-select>
      </b-field>

      <b-field label="Email">
        <b-input v-model="form.email" placeholder="Email address"></b-input>
      </b-field>

      <b-field label="Password">
        <b-field has-addons>
          <div class="control">
            <button
              type="button"
              class="button"
              placeholder="Email address"
              @click="generatePassword"
            >Generate</button>
          </div>

          <b-input v-model="form.password" placeholder="Review account password." expanded></b-input>
        </b-field>
      </b-field>

      <hr />

      <b-field label="Magazines that the account allowed to view.">
        <div class="py-4">
          <multiple-magazine-checkbox v-model="form.magazines"></multiple-magazine-checkbox>
        </div>
      </b-field>

      <div slot="foot">
        <button type="button" class="button" @click="$parent.close()">Cancel</button>

        <button
          class="button is-primary"
          :class="{'is-loading': form.processing}"
        >{{ account ? 'Update Account' : 'Create Account' }}</button>
      </div>
    </modal-card>
  </form>
</template>

<script>
import MultipleMagazineCheckbox from "@/components/MultipleMagazineCheckbox";

export default {
  components: {
    MultipleMagazineCheckbox
  },

  props: {
    account: {
      type: Object
    },

    whenSaved: {
      type: Function,
      default: () => () => {}
    }
  },

  data() {
    return {
      form: new window.Form({
        publisher_id: this.account ? this.account.publisher_id : null,
        email: this.account ? this.account.email : null,
        password: null,
        magazines: this.account ? this.account.magazines.map(a => a.id) : []
      })
    };
  },

  computed: {
    title() {
      return this.account ? "Edit Account" : "Create Account";
    }
  },

  methods: {
    generatePassword() {
      this.form.password = Math.random()
        .toString(36)
        .substring(5);
    },

    handleSubmit() {
      if (this.account) {
        return this.updateAccount(this.account);
      }

      this.createAccount();
    },

    createAccount() {
      this.form.post(`/admin/api/review/accounts`).then(() => {
        this.whenSaved();

        this.$buefy.toast.open("New account has been created.");

        this.$parent.close();
      });
    },

    updateAccount(account) {
      this.form.put(`/admin/api/review/accounts/${account.id}`).then(() => {
        this.whenSaved();

        this.$buefy.toast.open("Account has been updated.");

        this.$parent.close();
      });
    }
  }
};
</script>
